import React from "react";
export default function Loader() {
    return (
        <div className="fixed top-0 bottom-0 right-0 left-0 h-screen w-screen z-50 bg-black-op25">
            <div className="w-full top-0 progress">
                <div className="indeterminate" />
            </div>
        </div>
    )
}